export const COGNITO = {
  REGION: 'ap-southeast-2',
  USER_POOL_ID: 'ap-southeast-2_inXztPxtP',
  APP_CLIENT_ID: '3o3053pvdc2796sk102tgfmjaq',
}
